import {
  makeStyles,
  shorthands,
  tokens,
  type GriffelStyle,
} from "@fluentui/react-components";
import type { Appearance } from "../data";

type Styles = {
  root: GriffelStyle;
  dropdown: GriffelStyle;
  truncatedText: GriffelStyle;
  placeholderText: GriffelStyle;
  optionContainer: GriffelStyle;
  optionBadge: GriffelStyle;
};

const defaultStyles: Styles = {
  root: {
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    justifyContent: "flex-start",
    ...shorthands.gap("1rem"),
  },

  optionContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
    overflow: "hidden",
  },

  optionBadge: {
    marginRight: "6px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  dropdown: {
    minWidth: "130px",
    maxWidth: "240px",
    width: "20vw",
    "@media (max-width: 480px)": {
      minWidth: "unset",
      maxWidth: "100%",
    },
  },

  truncatedText: {
    overflowX: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  placeholderText: {
    color: tokens.colorNeutralForeground4,
  },
};

const singleColumnStyles: Styles = {
  ...defaultStyles,
  dropdown: {
    ...defaultStyles.dropdown,

    "@media (max-width: 480px)": {
      minWidth: "unset",
      maxWidth: "148px",
    },

    "& button": {
      color: tokens.colorNeutralForeground1,
      fontSize: tokens.fontSizeBase300,
      fontStyle: "normal",
      fontWeight: tokens.fontWeightSemibold,
      lineHeight: "20px",
    },
  },
};

export const useInAppStyles = makeStyles(defaultStyles);
export const useCopilotLabStyles = makeStyles(defaultStyles);
export const useM365Styles = makeStyles(defaultStyles);
export const useSingleColumnStyle = makeStyles(singleColumnStyles);

export const useStyles = (appearance?: Appearance) => {
  switch (appearance) {
    case "in-app":
      return useInAppStyles;
    case "web":
      return useCopilotLabStyles;
    case "m365":
    case "bing-web":
    case "win-copilot":
      return useM365Styles;
    case "bing-mobile":
    case "underside":
    case "single-col":
      return useSingleColumnStyle;
    default:
      return useInAppStyles;
  }
};
